import accessToken from "../../helpers/accessToken";
import router from "../../router/index";
import Mixins from "../../mixins/GlobalMixins";
import API_URL from "../../helpers/apiUrls";

const state = {
  orderSuccessDetails: null,
  orderFailedDetails: null,
  brandDetails:{
    brandId:null,
    brandName:null,
    productId:null,
    productName:null,
  },
  amount:null,
};

const mutations = {
  SET_ORDED_SUCCESS: (state, value) => {
    state.orderSuccessDetails = value;
  },

  SET_ORDED_FAILED: (state, value) => { console.log("vuexOrderF", state, value);
    state.orderFailedDetails = value;
  },

  SET_BRAND_DETAILS: (state, value) => {
    state.brandDetails.brandId = value.product_orders[0].business_product.brand?.id?value.product_orders[0].business_product.brand.id:'';
    state.brandDetails.brandName = value.product_orders[0].business_product.brand?.name?value.product_orders[0].business_product.brand.name:'';
    state.brandDetails.productId=value.product_orders[0].business_product.id;
    state.brandDetails.productName=value.product_orders[0].business_product.product_name;
    sessionStorage.setItem('pid',value.product_orders[0].business_product.id);
    sessionStorage.setItem('pname',value.product_orders[0].business_product.product_name);
    sessionStorage.setItem('brand-id',value.product_orders[0].business_product.brand?.id?value.product_orders[0].business_product.brand.id:'');
    sessionStorage.setItem('brand-name',value.product_orders[0].business_product.brand?.name?value.product_orders[0].business_product.brand.name:'');
   },

  SET_AMOUNT: (state, value) => {
    state.amount = value;
    sessionStorage.setItem('amt',value);
  },
};

const actions = {
  // TURN THE MASTER LOADER ON OR OFFs
  // toggleLoader({state}, value) {
  //     state.masterLoader = value;
  // },

  // SET THE RETRIEVE DETAILS OF THE USER
  setOrderSuccessDetails({ commit }, data) {
    commit("SET_ORDED_SUCCESS", data);
  },

  setOrderFailedDetails({ commit }, data) {
    commit("SET_ORDED_FAILED", data);
  },

  setBrandDetails({ commit }, data) {
    commit("SET_BRAND_DETAILS", data);
  },

  setAmount({commit},data){
    commit("SET_AMOUNT",data)
  }

  // REFRESH TOKEN WHEN THE TOKEN IS EXPIRED AND RE-CALL THE API WHICH IS QUEUED.

  // IMAGE UPLOAD
};

const getters = {
  GET_ORDER_SUCCESS_DETAILS: (state) => state.orderSuccessDetails,

  GET_ORDER_FAILED_DETAILS: (state) => state.setOrderFailedDetails,

  GET_BRAND_DETAILS: (state) => state.brandDetails,

  GET_AMOUNT: (state) => state.amount
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
